var styles = {"box":"ForgotPasswordWrapper_box_27yvy_1","success":"ForgotPasswordWrapper_success_27yvy_5","step-1":"ForgotPasswordWrapper_step-1_27yvy_13","step-2":"ForgotPasswordWrapper_step-2_27yvy_17","step-3":"ForgotPasswordWrapper_step-3_27yvy_21"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
